export default {"src":"/_next/static/media/0x1dab2a526c8ac1ddea86838a7b968626988d33de.a83a904b.svg","height":27,"width":27,"blurWidth":0,"blurHeight":0};